import { render, staticRenderFns } from "./RepIndiNal.vue?vue&type=template&id=190b45df&"
import script from "./RepIndiNal.vue?vue&type=script&lang=js&"
export * from "./RepIndiNal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports